module.exports = __webpack_public_path__ + "static/media/ProductIconBlack.6c146a26.svg";